import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
  supportFiles: { count: 0, rows: [] },
  loading: false,
};

const requestSupportFilesStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchSupportFilesSuccess = (state, action) => {
  return updateObject(state, {
    supportFiles: action.supportFiles,
    loading: false
  });
};

const requestSupportFilesFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteSupportFilesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const checkDeleteSupportFilesSuccess = (state, action) => {
  return updateObject(state, {
    checkDelete: action.checkDelete,
    loading: false
  });
}

const updateSupportFilesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const postSupportFilesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_SUPPORT_FILES_START: return requestSupportFilesStart(state, action);
    case actionTypes.FETCH_SUPPORT_FILES_SUCCESS: return fetchSupportFilesSuccess(state, action);
    case actionTypes.REQUEST_SUPPORT_FILES_FAIL: return requestSupportFilesFail(state, action);
    case actionTypes.DELETE_SUPPORT_FILES_SUCCESS: return deleteSupportFilesSuccess(state, action);
    case actionTypes.UPDATE_SUPPORT_FILES_SUCCESS: return updateSupportFilesSuccess(state, action);
    case actionTypes.POST_SUPPORT_FILES_SUCCESS: return postSupportFilesSuccess(state, action);
    default: return state;
  }
};

export default reducer;